import { Grid } from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import IGridComponent from '../../../components/grid/i-grid.component';
import { getCostingQualityData } from '../../costing/costing.services';
import SpecsComponent from '../../master-data/specs/specs.component';
import { AppContext } from '../../../app-context';
import IButton from '../../../components/button/i-button.component';
import QualityParamsComponent from './quality-params.component';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const QualityCostingComponent = (props: any) => {
  const [openSpecs, setOpenSpecs] = useState(false);
  const rows: GridRowsProp = [];
  const [detailRows, setDetailRows] = useState(rows);
  const [popupRowData, setPopupRowData] = useState(null);
  const appContext = useContext(AppContext);
  const [openQlty, setOpenQlty] = useState(false);
  const [linkId, setLinkId] = useState(null);
  const [inputCode, setInputCode] = useState();
  const [linkSerial, setLinkSerial] = useState(null);
  const [challanCount, setChallanCount] = useState(0);

  const columns: GridColDef[] = [
    { field: 'serial', headerName: '#', filterable: false, sortable: false, width: 5 },
    { 
      field: 'code', headerName: 'Code', filterable: false, sortable: false, width: 120,
      renderCell: (params) => { return <div className="cell-link" onClick={() => { openSpecsPopup(params) }}>{params.row.code}</div> }
    },
    {
      field: 'dependency', headerName: 'Dependency', filterable: false, sortable: false, width: 100, editable: false,
    },
    {
      field: 'outputDesc', headerName: 'Output Details', filterable: false, sortable: false, width: 220, editable: false,
    },
    {
      field: 'qltyParams', headerName: 'Quality', filterable: false, sortable: false, width: 65, editable: false,
      renderCell: (params) => { return 'Set' === params.row.qltyParams ? 
                                       <CheckCircleOutlinedIcon fontSize='small' color="success"/> : 
                                       <CancelOutlinedIcon fontSize='small' color="error"/>}
    }
  ];

  useEffect(() => {
    getCostingQualityData(props.orderId, props.costingId, appContext,
      (response: any) => {
        setDetailRows(response.data);
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });

  }, []);

  const openSpecsPopup = (params: any) => {
    setPopupRowData(params.row);
    setOpenSpecs(true);
  }

  const handleCellDoubleClick = (value: any) => {
    const field = value.field;
    if('qltyParams' === field) {
      setLinkSerial(value.row.serial);
      setLinkId(value.row.linkId);
      setInputCode(value.row.code);
      setChallanCount(value.row.challanCount);
      setPopupRowData(value.row);
      setOpenQlty(true);
    }
  }

  const handleCloseSpecs = () => {
    setOpenSpecs(false);
  }

  const handleCloseQlty = () => {
    setOpenQlty(false);
  }

  const onClose = () => {
    let count = 0;
    for(let i = 0; i < detailRows.length; ++i) {
      if('Set' === detailRows[i].qltyParams) {
        ++count;
      }
    }

    props.close(count);
  }

  const onCancel = (value: any) => {
    detailRows[Number(linkSerial) - 1].qltyParams = value ? 'Set' : 'Not Set';
    setOpenQlty(false);
  }

  const onOk = () => {
    detailRows[Number(linkSerial) - 1].qltyParams = 'Set';
    setOpenQlty(false);
  }

  return <div className='master-detail'>
    <Grid container spacing={3}>
      <IGridComponent title='' rows={detailRows} columns={columns} getRowId={(row: any) => row.linkId} apiRef={props.apiRef} 
        maxHeight={'70vh'} hideFooterPagination={true} hideFooter={true} cellDoubleClick={handleCellDoubleClick}/>
    </Grid>
    <div className='btn-panel'>
      <IButton name='close' label='Close' color="primary" onActionEvent={onClose}/>
    </div>
    <IDialogComponent onClose={handleCloseSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
      dialogBody={<SpecsComponent data={popupRowData} />} />
    <IDialogComponent onClose={handleCloseQlty} open={openQlty} title='Quality Parameters'
      dialogBody={<QualityParamsComponent specData={popupRowData} orderId={props.orderId} costingId={props.costingId} linkId={linkId}
                    inputCode={inputCode} challanCount={challanCount} costingCode={props.costingCode} onCancel={onCancel} onOk={onOk}/>} />
  </div>
}

export default QualityCostingComponent;
